{
  "about": {
    "title": "关于Spring Boot Admin",
    "label": "关于我们"
  }
}
